import React, {Fragment} from 'react';

import withClass from '../../../../hoc/withClass';
import logo from '../../../../assets/images/eboard-logo.png';

const brandInfo = () => (
    <Fragment>
        <div className="brand">
            <img className="brand-img" src={logo} alt="eBoard Logo" />
        </div>
        <p className="font-size-20">"MANAGEMENT IS DOING THINGS RIGHT, BUT LEADERSHIP IS DOING RIGHT THINGS"</p>
    </Fragment>
);

export default withClass(brandInfo, 'page-brand-info');